import LoaderImg from '../../../assets/images/loader.gif';
import { LoaderProps } from './type';
import { LoaderContainer } from './loader.styled';

export const Loader = ({
  width, className, height, label,
}:LoaderProps) => {
  return (
    <LoaderContainer className="loader-container">
      <img src={LoaderImg} alt={LoaderImg} width={width} height={height} className={className || undefined} />
      <p>{label}</p>
    </LoaderContainer>
  );
};
